<template>
<div class="container-fluid" id="EmailMembers">
	<div class="page-header gold mt-4 mb-3">
		<back-btn></back-btn>
		<h2 class="mb-0">
			<i class="fas fa-envelope pr-2"></i> Email Members
		</h2>
	</div>

	<tip-tap-editor editor_type="default" />

</div>
</template>


<script>
import TipTapEditor from '../components/TipTapEditor.vue';
import BackBtn from '@/components/BackBtn.vue';

export default {
	name: "EmailMembers",
	components:{
		TipTapEditor,
		BackBtn,
	},
	props: {
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	methods: {
	}
};
</script>

<style scoped>
.page-header {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 14px;
	position: relative;
	padding: 0 52px;
}
.page-header h2 {
	min-width: 0;
	text-align: center;
	word-break: break-word;
}
.gold {
	color: #d6b674;
}

</style>
